module.exports = __webpack_public_path__ + "media/bootstrap-icons/thermometer-half-205ce593.svg";